import React from "react";
import PropTypes from "prop-types";
import {
  BrandWrapper,
  Brand,
  PremiumBrand,
  PortalBrand,
  PartnerNetworkBrand,
} from "./styles/brand-styles";

const BrandLogo = ({ rootPageUrl, user }) => {
  const {
    isPremiumEmployer,
    isPortalEmployer,
    isPortalRecruiter,
    isPartnerRecruiter,
  } = user;

  const PremiumLogo = () => (
    <BrandWrapper id="premium-logo">
      <a href={rootPageUrl} title="Hiring Hub">
        <PremiumBrand />
      </a>
    </BrandWrapper>
  );

  const PortalLogo = () => (
    <BrandWrapper id="portal-logo">
      <a href={rootPageUrl} title="Hiring Hub Portal">
        <PortalBrand />
      </a>
    </BrandWrapper>
  );

  const VanillaLogo = () => (
    <BrandWrapper id="logo">
      <a href={rootPageUrl} title="Hiring Hub">
        <Brand />
      </a>
    </BrandWrapper>
  );

  const PartnerNetworkLogo = () => (
    <BrandWrapper id="portal-logo">
      <a href={rootPageUrl} title="Hiring Hub Portal">
        <PartnerNetworkBrand />
      </a>
    </BrandWrapper>
  );

  if (isPremiumEmployer) return <PremiumLogo />;
  if (isPortalEmployer) return <PortalLogo />;
  if (isPortalRecruiter) return <PortalLogo />;
  if (isPartnerRecruiter) return <PartnerNetworkLogo />;
  return <VanillaLogo />;
};

BrandLogo.propTypes = {
  rootPageUrl: PropTypes.string.isRequired,
  user: PropTypes.shape({
    isPremiumEmployer: PropTypes.bool,
    isPortalEmployer: PropTypes.bool,
    isPortalRecruiter: PropTypes.bool,
    isPartnerRecruiter: PropTypes.bool,
  }).isRequired,
};

export default React.memo(BrandLogo);
